import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommandService } from '@core/services/command.service';
import { PlatformCommand } from '@shared/commands/command-base';
import { StringInputDialogBoxComponent } from '@shared/components/string-input-dialog-box/string-input-dialog-box.component';
import { Api } from '@shared/constants/common-field.constants';
import { NgxQuillEditorService } from '@shared/services/ngx-quill-editor.service';
import { take } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-support-resolution',
  templateUrl: './support-resolution.component.html',
  styleUrl: './support-resolution.component.scss'
})

export class SupportResolutionComponent implements OnInit {
  public showAddButton: boolean = true;
  
  @Input() resolution: string;
  @Input() ticketId: string;

  constructor(private commandService: CommandService) {
  }

  ngOnInit(): void {
    if(this.resolution && this.resolution != '')
    {
      this.showAddButton = false;
    }
  }

  
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        this.showAddButton = false;
      },
    error => {
      console.error('Failed To Execute command', error);
    });

  }
}
 addResolutionFromBackend()
 {
    let command = new PlatformCommand('AddTicketResolutionDialogCommand', Api.TaskManager);
    command.setValue('ticketId', this.ticketId);
    command.setValue('resolution', this.resolution);
    this.executeCommandToApi(command);
 }
  
}